import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import {
  Sheet,
  SheetContent,
  SheetTitle,
} from "@/components/ui/sheet"
import { ScrollArea } from "@/components/ui/scroll-area"
import { Logo } from "@/components/common/Logo"
import {
  GeneratorSidebarContent,
  type GeneratorSidebarProps,
} from "@/features/generator/components/GeneratorSidebar"

interface MobileSidebarDrawerProps extends Omit<GeneratorSidebarProps, "className"> {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function MobileSidebarDrawer({
  open,
  onOpenChange,
  disabled = false,
  showQueueState = false,
  onGenerate,
  queueState,
}: MobileSidebarDrawerProps) {
  const { t } = useTranslation()
  // 생성 버튼 클릭 시 드로어 닫기
  const handleGenerate = () => {
    onGenerate?.()
    onOpenChange(false)
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="left"
        className="w-[320px] p-0 flex flex-col [&>button]:hidden"
      >
        {/* 접근성을 위한 숨겨진 제목 */}
        <SheetTitle className="sr-only">{t("generator.settingsTitle")}</SheetTitle>

        {/* Header */}
        <div className="h-14 flex items-center px-4 border-b border-slate-100 shrink-0">
          <Link to="/" onClick={() => onOpenChange(false)}>
            <Logo size="sm" />
          </Link>
        </div>

        {/* Scrollable Content */}
        <ScrollArea className="flex-1 px-4 py-4">
          <GeneratorSidebarContent
            disabled={disabled}
            showQueueState={showQueueState}
            onGenerate={handleGenerate}
            queueState={queueState}
            onNavigateAway={() => onOpenChange(false)}
          />
        </ScrollArea>
      </SheetContent>
    </Sheet>
  )
}
